import { Link } from 'react-router-dom';

export const GroupKeyLink = (props: { groupKey: string; text?: string }) => (
  <div style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
    <Link to={`/application-group/${props.groupKey}`}>
      {props.text || props.groupKey.substr(0, 8).toUpperCase()}
    </Link>
  </div>
);
